'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/* eslint-disable max-len */

exports.default = {
	icon: 'M8,6.5v3h4.291c-0.526,2.01-2.093,3.476-4.315,3.476C5.228,12.976,3,10.748,3,8c0-2.748,2.228-4.976,4.976-4.976c1.442,0,2.606,0.623,3.397,1.603L13.52,2.48C12.192,0.955,10.276,0,8,0C3.582,0,0,3.582,0,8s3.582,8,8,8s7.5-3.582,7.5-8V6.5H8z',
	popupUrl: 'https://plus.google.com/share?url={url}',
	popupWidth: 500,
	popupHeight: 500
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/social-likes-next/lib/services/plusone.js
// module id = 27
// module chunks = 0